import { PublicLayout } from '../../components/layout/PublicLayout';
import './legal.css';

export function AbusePage() {
  return (
    <PublicLayout>
      <div className="legal-page">
        <div className="legal-prose">
          <span className="legal-chip">Report abuse</span>
          <h1>Report abuse</h1>
          <p>
            Every shared Sarnia Builder preview includes a report-abuse link. If you have seen harmful, infringing or
            unlawful content on a preview we serve, please let us know. You can also report directly here.
          </p>
          <h2>What to include</h2>
          <ul>
            <li>The preview address (the link you were sent).</li>
            <li>A short reason for the report.</li>
            <li>Any relevant details that help us review the site.</li>
            <li>Optionally, your email address so we can reply.</li>
          </ul>
          <p>
            Reports are sent to the operator and handled within a reasonable time. We may suspend a site or account if the
            report is founded.
          </p>
          <p>
            Contact the operator directly at <a href="mailto:abuse@sarnia.digital">abuse@sarnia.digital</a>.
          </p>
        </div>
      </div>
    </PublicLayout>
  );
}
